export const API_KEY = "api_key=2b1fd64cd979487c5f0deddc18cc2dad";
export const URL_BASE_MOVIES = "https://api.themoviedb.org/3/movie/";

export const URL_MOVIES = "https://api.themoviedb.org/3/movie/popular?";
export const URL_VIDEO_MOVIES = "/videos?";

export const URL_CREDITS = "/credits?";

export const URL_TV_POPULAR = "https://api.themoviedb.org/3/tv/popular?";
export const URL_BASE_TV = "https://api.themoviedb.org/3/tv/";

export const URL_TOP_RATED_MOVIES =
  "https://api.themoviedb.org/3/movie/top_rated?";

export const URL_TOP_RATED_TV = "https://api.themoviedb.org/3/tv/top_rated?";

export const BASE_URL_IMG = "https://image.tmdb.org/t/p/";
export const SIZE_IMAGE = "original";
export const SMALL_SIZE = "w300";
export const MEDIUM_SIZE = "w500";

export const URL_GENRES = "https://api.themoviedb.org/3/genre/movie/list?";
export const URL_GENRES_TV = "https://api.themoviedb.org/3/genre/tv/list?";
export const URL_LENGUAGE = "language=en-US";

export const API_YOUTUBE_URL = "https://www.youtube.com/embed/";
export const URL_IMG_YOUTUBE = "http://img.youtube.com/vi/";
export const IMG_SIZE_YOUTUBE = "mqdefault.jpg";

export const URL_SEARCH = "https://api.themoviedb.org/3/search/multi?";
export const URL_SEARCH_MOVIES = "https://api.themoviedb.org/3/search/movie?";
export const URL_SEARCH_TV = "https://api.themoviedb.org/3/search/tv?";
export const URL_SEARCH_PERSONS = "https://api.themoviedb.org/3/search/person?";
export const URL_QUERY = "query=";
export const SEARCH_RESULTS = "/search";
export const SEARCH = "/search?q=";

export const STREAMING_TV = "https://api.themoviedb.org/3/tv/on_the_air?";
export const URL_TV_AIRING = "https://api.themoviedb.org/3/tv/airing_today?";
export const URL_TEATHERS = "https://api.themoviedb.org/3/movie/now_playing?";

export const COLLECTIONS = "/collections";
export const COLLECTION_ID = "/collections/:typeCollection/:collectionId";

export const SECTION_MOVIES = "/movies/page/:numPage";
export const URL_SECTION_MOVIES = "/movies/page/1";
export const URL_MOVIES_SECTION = "/movies";

export const SECTION_COLLECTION_ID =
  "/:typeCollection/page/:numPage/id/:collectionId";

export const SECTION_TV = "/tv/page/:numPage";
export const URL_TV = "/tv/page/1";
export const URL_SECTION_TV = "/tv";
// export const SECTION_TV_ID = "/:typeCollection/:collectionId";

export const PLAY_VIDEO = "/play";
export const MODAL_LATEST_ADVANCES =
  "/collections/play/:typeCollection/:collectionId";

export const CATEGORY_TV_AIRING = "tv";
export const CATEGORY_TEATHERS = "movies";
export const CATEGORY_STREAMING = "streaming";

export const PAGE = "&page=";
export const MAX_PAGES = 500;

export const DETAIL_SECTION = "/:typeCollection/:collectionId/detail";

// Tamaño pequeño: https://img.youtube.com/vi/IDENTIFICADOR_DEL_VIDEO/default.jpg
// Tamaño mediano: https://img.youtube.com/vi/IDENTIFICADOR_DEL_VIDEO/hqdefault.jpg
// Tamaño estándar de las miniaturas: https://img.youtube.com/vi/IDENTIFICADOR_DEL_VIDEO/mqdefault.jpg
// Tamaño grande: https://img.youtube.com/vi/IDENTIFICADOR_DEL_VIDEO/sddefault.jpg
// Máxima calidad de la miniatura: https://img.youtube.com/vi/IDENTIFICADOR_DEL_VIDEO/maxresdefault.jpg
